import { render, staticRenderFns } from "./ScoreNew.vue?vue&type=template&id=000cc524&"
import script from "./ScoreNew.vue?vue&type=script&lang=js&"
export * from "./ScoreNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports